export default {"src":"/_next/static/media/PatientCentricity.de2bab3f.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};